import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { ChatList } from "./ChatList";
import { ChatInbox } from "./ChatInbox";
import { useDispatch, useSelector } from "react-redux";
import {
  getSenders,
  getSendersChats,
} from "../../../redux/actions/dbactions/chatActions";
import { Header } from "../../Header";
import { MessageIcon } from "../../../../assets/MessageIcon";

const ChatLayout = () => {
  const [defaultPage, setDefaultpage] = useState(false);
  const [listHide, setListHide] = useState(true);
  const [reciversID, setReciversID] = useState(null);
  const [participantName, setParticipantName] = useState("");
  const [photoUrl, setPhotoUrl] = useState(null);
  const dispatch = useDispatch();
  const { senders, isLoading, chatBox } = useSelector((state) => state.chats);
  const handleChats = (id, name, photo) => {
    setReciversID(id);
    setParticipantName(name);
    setPhotoUrl(photo)
    if (reciversID !== null) {
      dispatch(getSendersChats(reciversID));
      setDefaultpage(true);
      setListHide(false);
    }
  };
  const backActionList = () => {
    dispatch(getSenders());
    setDefaultpage(false);
    setListHide(true);
  };
  useEffect(() => {
    dispatch(getSenders());
  }, [dispatch]);
  const sendersList = senders?.usr?.rec[0]?.contact_list || [];
  const chatMessages = chatBox?.usr?.recs || [];
  return (
    <div>
      <Header pageTitle="Messages" icon={<MessageIcon />} />
    
    <div className="chatLayout">
      {listHide && (
        <ChatList
          sendersList={sendersList}
          isLoading={isLoading}
          handleChats={handleChats}
        />
      )}
      {defaultPage && (
        <ChatInbox
          backActionList={backActionList}
          chatMessages={chatMessages}
          participantName={participantName}
          photoUrl={photoUrl}
          reciverIDS={reciversID}
          setDefaultpage={setDefaultpage}
        />
      )}
    </div>
    </div>
  );
};
export default withRouter(ChatLayout);
